export default (entity = {}) => {
    return {
        id: entity.id || undefined,
        name: entity.name || '',
        contact: entity.contact || '',
        // websiteSupport: entity.websiteSupport || false,
        languages: entity.languages || ['he', 'en']
    };
};
